import { getTagDotColor } from '../utils/colors';
import { HighlightedOption, TagDataMap } from '../types';

interface TagDotIndicatorsProps {
  allTagIds: string[];
  highlightedOption: HighlightedOption;
  tagDataMap: TagDataMap;
  onDotClick: (tagId: string | null) => void;
  activeTagId: string | null;
  indicatorHeight: number | null;
}

const TagDotIndicators = ({ allTagIds, highlightedOption, tagDataMap, onDotClick, activeTagId, indicatorHeight }: TagDotIndicatorsProps) => {
  if (!allTagIds || allTagIds.length <= 1) return null;

  const dotSize = indicatorHeight ? Math.max(6, Math.min(14, Math.round(indicatorHeight * 0.8))) : 12;

  return (
    <span
      contentEditable={false}
      style={{
        position: 'absolute',
        top: indicatorHeight ? `${indicatorHeight / 2}px` : '0',
        left: '0px',
        transform: 'translate(-120%, -50%)',
        display: 'flex',
        flexDirection: 'row',
        gap: '2px',
        padding: '0 2px',
        userSelect: 'none',
      }}
    >
      {allTagIds.map((tagId) => (
        <span
          key={tagId}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onDotClick(tagId === activeTagId ? null : tagId);
          }}
          style={{
            width: `${dotSize}px`,
            height: `${dotSize}px`,
            borderRadius: '50%',
            backgroundColor: getTagDotColor(highlightedOption, tagDataMap[tagId]),
            display: 'inline-block',
            flexShrink: 0,
            cursor: 'pointer',
          }}
        />
      ))}
    </span>
  );
};

export default TagDotIndicators;
